/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'web-ui-components/lib/atoms/popovers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { contentPropTypes } from './payment.content';

const PaymentListHeader = ({
	fromLabel,
	toLabel,
	amtLabel,
	refLabel,
	dateLabel,
	typeLabel,
	showType,
	allowApplySameForAll,
	content,
	isAuthorisationEdit,
	typeTooltipHelpOpen,
	refTooltipHelpOpen,
	showSameRefPopover,
	showSameDatePopover,
	handleReferenceTooltipClick,
	handleTypeTooltipClick,
	handleSameRefClick,
	handleSameDateClick,
	copyDateToAll,
	copyRefToAll,
	allowDateApplySameForAll,
	showDate,
	showRefHelp,
}) => (
	<div className="c-o-list-payment__header">
		<div className="c-o-list-payment__header-cell c-o-list-payment__header-cell--from">
			<span className="c-o-list-payment__header-cell-label">{fromLabel}</span>
		</div>
		<div className="c-o-list-payment__header-cell c-o-list-payment__header-cell--to">
			<span className="c-o-list-payment__header-cell-label">{toLabel}</span>
		</div>
		<div className="c-o-list-payment__header-cell">
			<span className="c-o-list-payment__header-cell-label">{amtLabel}</span>
		</div>
		<div className="c-o-list-payment__header-cell">
			<span className="c-o-list-payment__header-cell-label">
				{refLabel}
				{showRefHelp && (
					<Popover
						id="popover-referenceHelp"
						className="reference-tooltip u-margin-left-1"
						placement="right"
						isOpen={refTooltipHelpOpen}
						content={content.referenceHelp}
						onClick={handleReferenceTooltipClick}
					>
						<Icon iconType="InfoOutlineLarge" />
					</Popover>
				)}
			</span>
			{allowApplySameForAll && (
				<div id="ref-same-for-all-wrapper" className="c-o-list-payment__header-cell-text-link">
					<label className="c-o-list-payment__checkbox-label" id="ref-same-for-all-label" htmlFor="ref-same-for-all">
						<Popover
							id="popover-sameRef"
							placement="left"
							isOpen={showSameRefPopover}
							content={content.sameRefPopoverMsg}
							onClick={handleSameRefClick}
							isButtonRequired={false}
						/>
						<Button onClick={copyRefToAll} id="copy-ref-to-all-button" size="xs">
							{content.copyToAllButton}
						</Button>
					</label>
				</div>
			)}
		</div>
		{showDate && (
			<div className="c-o-list-payment__header-cell">
				<span className="c-o-list-payment__header-cell-label">{dateLabel}</span>

				{allowDateApplySameForAll && (
					<div id="date-same-for-all-wrapper" className="c-o-list-payment__header-cell-text-link">
						<label
							className="c-o-list-payment__checkbox-label"
							id="date-same-for-all-label"
							htmlFor="date-same-for-all"
						>
							<Popover
								id="popover-sameDate"
								placement="left"
								className="popover-sameDate u-margin-left-1"
								isOpen={showSameDatePopover}
								content={content.sameDatePopoverMsg}
								onClick={handleSameDateClick}
								isButtonRequired={false}
							/>
							<Button onClick={copyDateToAll} id="copy-date-to-all-button" size="xs" disabled={isAuthorisationEdit}>
								{content.copyToAllButton}
							</Button>
						</label>
					</div>
				)}
			</div>
		)}
		{showType && (
			<div className="c-o-list-payment__header-cell type-header">
				<span className="c-o-list-payment__header-cell-label">
					{typeLabel}
					<Popover
						id="popover-paymentTypeHelp"
						className="type-tooltip u-margin-left-1"
						placement="right"
						isOpen={typeTooltipHelpOpen}
						content={content.paymentTypeHelp}
						onClick={handleTypeTooltipClick}
					>
						<Icon iconType="InfoOutlineLarge" />
					</Popover>
				</span>
			</div>
		)}
	</div>
);

PaymentListHeader.propTypes = {
	fromLabel: PropTypes.string.isRequired,
	toLabel: PropTypes.string.isRequired,
	amtLabel: PropTypes.string.isRequired,
	refLabel: PropTypes.string.isRequired,
	dateLabel: PropTypes.string.isRequired,
	typeLabel: PropTypes.string.isRequired,
	showType: PropTypes.bool.isRequired,
	allowApplySameForAll: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	isAuthorisationEdit: PropTypes.bool.isRequired,
	typeTooltipHelpOpen: PropTypes.bool.isRequired,
	refTooltipHelpOpen: PropTypes.bool.isRequired,
	showSameRefPopover: PropTypes.bool.isRequired,
	showSameDatePopover: PropTypes.bool.isRequired,
	handleReferenceTooltipClick: PropTypes.func.isRequired,
	handleTypeTooltipClick: PropTypes.func.isRequired,
	handleSameRefClick: PropTypes.func.isRequired,
	handleSameDateClick: PropTypes.func.isRequired,
	copyDateToAll: PropTypes.func.isRequired,
	copyRefToAll: PropTypes.func.isRequired,
	allowDateApplySameForAll: PropTypes.bool.isRequired,
	showDate: PropTypes.bool.isRequired,
	showRefHelp: PropTypes.bool,
};

export default PaymentListHeader;
